/* @flow */
import React, { Component } from 'react';
import { clamp, times } from 'lodash/fp';
import styled from '@emotion/styled';
import { rgba } from 'polished';
import { Linear, TweenMax } from 'gsap';

type Props = {
  percent: number,
  total?: number
};

type State = {
  numFilled: number
};

const Wrapper = styled.div({
  alignItems: 'stretch',
  display: 'flex',
  flexDirection: 'column-reverse',
  justifyContent: 'flex-end',
  padding: '0 25%',
  width: '100%'
});

const Indicator = styled.span(
  {
    borderRadius: 2,
    display: 'block',
    height: 3,
    marginTop: 1
  },
  ({ filled, theme }) =>
    filled
      ? {
          backgroundColor: theme.color.widgetSecondary
        }
      : {
          backgroundColor: rgba(theme.color.basis5, 0.25)
        }
);

class LineMeter extends Component<Props, State> {
  props: Props;

  state: State = {
    numFilled: 0
  };

  tweener: TweenMax; // eslint-disable-line react/sort-comp

  static defaultProps = {
    total: 8
  };

  componentDidMount() {
    const { percent } = this.props;

    this.tweener = TweenMax.from(
      {
        value: clamp(0, 1, percent)
      },
      0.5,
      {
        delay: 0.2,
        value: 0,
        ease: Linear.easeNone,
        onUpdate: this.handleUpdate,
        onUpdateParams: ['{self}']
      }
    );
  }

  componentWillUnmount() {
    this.tweener.kill();
  }

  handleUpdate = ({ target }) => {
    this.setState((state, { total }) => ({
      numFilled: Math.floor(target.value * total)
    }));
  };

  render() {
    const { total } = this.props;
    const { numFilled } = this.state;

    return (
      <Wrapper>
        {times(
          i => (
            <Indicator key={i} filled={i < numFilled} />
          ),
          total
        )}
      </Wrapper>
    );
  }
}

export default LineMeter;
